export default "__VITE_ASSET__CXYLv2xU__"